// Excel експортът на справка „Фактури" — досега тази справка нямаше експорт.
//
// Редовете идват ФИЛТРИРАНИ и ПОДРЕДЕНИ от таблицата (`onFilteredRowsChange`),
// не суровият отговор: файлът повтаря екрана, включително филтъра „Състояние"
// в колоната. Сумите излизат като ЧИСЛА, за да се сумират в Excel.
//
// Разликата спрямо екрана е една: тук се изнасят и колоните, изгасени по
// подразбиране (час, ДДС %, необлагаемо). В таблицата те заемат място ред след
// ред, а в счетоводния файл трябва да ги има винаги.
//
// БЕЗ собствен времеви печат — `exportToExcel` вече лепи `_${stamp}`.

import dayjs from "dayjs";
import type { TFunction } from "i18next";

import { exportToExcel } from "../../../../utils/excelExport";
import type { InvoiceRow } from "./invoicesMath";

/** Датите се форматират РЪЧНО — `bg-BG` locale лепи „ г." и в клетката. */
const formatDate = (iso: string) => {
  const parsed = dayjs(iso);
  return parsed.isValid() ? parsed.format("DD.MM.YYYY") : "";
};

const formatTime = (iso: string) => {
  const parsed = dayjs(iso);
  return parsed.isValid() ? parsed.format("HH:mm") : "";
};

export const exportInvoices = (rows: readonly InvoiceRow[], t: TFunction) => {
  const title = t("reportsPage.invoices");

  exportToExcel<InvoiceRow>({
    filename: title,
    sheetName: title,
    columns: [
      {
        header: t("invoicesReport.colNumber"),
        value: (row) => row.number,
        width: 16,
      },
      {
        header: t("invoicesReport.colDate"),
        value: (row) => formatDate(row.issueDate),
        width: 14,
      },
      {
        header: t("invoicesReport.colTime"),
        value: (row) => formatTime(row.createdAt),
        width: 10,
      },
      {
        header: t("invoicesReport.colCustomer"),
        value: (row) => row.customerName,
        width: 28,
      },
      {
        header: t("invoicesReport.colEik"),
        value: (row) => row.customerEik,
        width: 16,
      },
      {
        header: t("reportsPage.invoicesColType"),
        value: (row) => row.typeLabel,
        width: 14,
      },
      {
        header: t("reportsPage.invoicesColStatus"),
        value: (row) => row.statusLabel,
        width: 14,
      },
      {
        header: t("invoicesReport.colTaxable"),
        value: (row) => row.taxable,
        width: 16,
      },
      {
        header: t("invoicesReport.colVat"),
        value: (row) => row.vat,
        width: 14,
      },
      {
        header: t("invoicesReport.colVatRate"),
        value: (row) => row.vatRate,
        width: 10,
      },
      {
        header: t("invoicesReport.colNonTaxable"),
        value: (row) => row.nonTaxable,
        width: 16,
      },
      {
        header: t("invoicesReport.colGrand"),
        value: (row) => row.grandTotal,
        width: 16,
      },
    ],
    rows: [...rows],
  });
};
